import {
  alphaMessage,
  maxLengthMessage,
  requiredMessage,
} from "../validationMessages";
import { nameSurnameValidator as nameSurnameValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 29;

export const nameSurnameValidator = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(nameSurnameValidatorRegex, {
    message: alphaMessage,
    excludeEmptyString: true,
  });
export const nameSurnameValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage)
  .matches(nameSurnameValidatorRegex, alphaMessage);
